import { observable, set } from 'mobx';

class GiftCard {
  @observable amount: number | string;

  @observable balance: number | string;

  @observable number: string;

  @observable id: number;

  static fromJSON(data: GiftCard): GiftCard {
    const giftCard = new GiftCard();
    set(giftCard, data);

    return giftCard;
  }
}

export default GiftCard;
